import { LockIcon } from 'lucide-react';
import { motion } from 'motion/react';

const backgroundVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { ease: 'easeInOut', duration: 0.2 } },
};

const loginModalVariants = {
  hidden: { translateY: 10 },
  visible: { translateY: 0, transition: { ease: 'easeInOut', duration: 0.2 } },
};

const AccessRevokedModal = () => {
  return (
    <div className="flex flex-col bg-[#ffffff] w-[24rem] h-[18rem] rounded-xl justify-center">
      <div className="flex flex-col py-5 px-4 gap-4 items-center">
        <div className="rounded-full w-14 h-14 bg-elementGray flex flex-col items-center justify-center">
          <LockIcon color="#666666" size={24} />
        </div>
        <div className="text-center">
          <h2 className="text-2xl">Access Revoked</h2>
          <p>Please contact your system admin.</p>
        </div>
      </div>
    </div>
  );
};

const AccessRevoked = ({ redirect }) => {
  return (
    <motion.div
      className="w-screen h-dvh flex items-center justify-center backdrop-blur-sm bg-[#00000010] fixed z-50"
      initial="hidden"
      animate="visible"
      variants={backgroundVariants}
    >
      <motion.div
        initial="hidden"
        animate="visible"
        variants={loginModalVariants}
      >
        <AccessRevokedModal redirect={redirect} />
      </motion.div>
    </motion.div>
  );
};

export default AccessRevoked;
